import React, { useEffect } from "react";

export const enum BackgroundTypeEnum {
  SOLID = "solid",
  GRADIENT = "gradient",
  IMAGE = "image",
}
export const BACKGROUND_SETTING_DEFAULT_VALUE = {
  BACKGROUND_TYPE: "solid",
  IMAGE: null,
  BLUR: 0,
  OVERLAY_ENABLE: false,
  OVERLAY_COLOR: "#00000066",
  COLOR_SOLID: "#F0F0F0",
  COLOR_GRADIENT_GENERATOR_FIRST_COLOR: "#f9a8d4ff",
  COLOR_GRADIENT_GENERATOR_SECOND_COLOR: "#a5b4fcff",
  COLOR_GRADIENT_INTENSITY: 300,
  COLOR_GRADIENT_DIRECTION: "to bottom",
};
const BackgroundStyle = ({ backgroundSetting }) => {
  
  useEffect(() => {
    const { color, gradient, image, type, blur } = backgroundSetting || {};
    //Background solid color
    if (type === BackgroundTypeEnum.SOLID) {
      document.documentElement.style.setProperty(
        "--background-color",
        color ?? BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_SOLID
      );
      document.documentElement.style.setProperty("--background-image", "none");
    }
    //Background gradient color
    if (type === BackgroundTypeEnum.GRADIENT) {
      document.documentElement.style.setProperty(
        "--background-image",
        gradient ??
          `linear-gradient(${BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_GRADIENT_DIRECTION}, ${BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_GRADIENT_GENERATOR_FIRST_COLOR}, ${BACKGROUND_SETTING_DEFAULT_VALUE.COLOR_GRADIENT_GENERATOR_SECOND_COLOR})`
      );
      document.documentElement.style.setProperty("--background-color", "none");
    }
    //Background image
    
    if (image && type === BackgroundTypeEnum.IMAGE) {
      document.documentElement.style.setProperty(
        "--background-image",
        `url('${image}')`
      );
      document.documentElement.style.setProperty("--background-color", "none");
    }
    //Background blur
    document.documentElement.style.setProperty(
      "--background-blur",
      blur && typeof blur === "number" && type === BackgroundTypeEnum.IMAGE
        ? `${blur}px`
        : `${BACKGROUND_SETTING_DEFAULT_VALUE.BLUR}px`
    );
  }, [backgroundSetting]);
  return null;
};

export default BackgroundStyle;
